module.exports = __webpack_public_path__ + "static/media/best_part.5240f9f7.png";